import React from "react";

const MainContext = React.createContext({
	isMobileSidebarOpen: false,
	isSidebarOpen: false,
	toggleMobileSidebar: () => {},
});

export default MainContext;